import { getAllOpenedTransactions } from '../../../services/pos/transactions';

export const OPENED_TRANSACTIONS_FETCH = 'OPENED_TRANSACTIONS_FETCH';
export const OPENED_TRANSACTIONS_SUCCESS = 'OPENED_TRANSACTIONS_SUCCESS';
export const OPENED_TRANSACTIONS_ERROR = 'OPENED_TRANSACTIONS_ERROR';

export const getOpenedTransactions = () => async (dispatch) => {
  dispatch({ type: OPENED_TRANSACTIONS_FETCH });
  try {
    const payload = await getAllOpenedTransactions();
    dispatch({ type: OPENED_TRANSACTIONS_SUCCESS, payload });
  } catch (error) {
    const errorResponse = error.response;

    let errorCode;
    switch (errorResponse?.data?.error) {
      case 'INVALID_CREDENTIALS':
        errorCode = errorResponse?.data?.error;
        break;
      default:
        errorCode = 'UNKNOWN_ERROR';
    }

    dispatch({ type: OPENED_TRANSACTIONS_ERROR, error: errorCode });
  }
};
